import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import StepIndicator from "./StepIndicator";
import RangeCalendar from "./RangeCalendar";
import BranchMachineAssign from "./BranchMachineAssign";
import { BRANCHES, MACHINES } from "../data/constants";
import { formatDate } from "../utils/date";
import { BranchOfficeFetchAPI } from "../../../api/BranchOffices";
import { MachinesFetchAPI } from "../../../api/Machines";
import { getRandomColor } from "../../utils/RandomColor";
import Select from 'react-select';

export default function CreateEventModal({
  open,
  events,
  onClose,
  mobile,
  step,
  totalSteps,
  newEvent,
  setNewEvent,
  hovered,
  setHovered,
  rangePM,
  rangePY,
  setRangePM,
  setRangePY,
  canNext,
  nextStep,
  prevStep,
  onCreate,
  branchOfficesData,
  setBranchOfficesData,
  setSelectEventToUpdate,
  selectEventToUpdate,
  type,
  setType
}) {

  let token = localStorage.getItem('x-access-token');

  //Function to get the machines of the branch office
  const getMachines = async (branchoffice_id) => {
    try {
      //We get the machines of the branch office
      const machines = await MachinesFetchAPI.getMachinesByBranchOffice(branchoffice_id, token);
      // Filtramos solo las máquinas con nombre 'Smart pos' o 'Smart Pay'
      const updatedBranchOffices = branchOfficesData.map((b) => {
        if (b.id === branchoffice_id) {
          let formatdatamachine = [];
          machines.data.data.forEach((m) => {
            formatdatamachine.push({ id: m.machine_per_branch_id, name: m.machine_name, type: m.name, color: getRandomColor() });
          });
          return { ...b, machines: formatdatamachine };
        }
        return b;
      });

      setBranchOfficesData(updatedBranchOffices);
    } catch (err) {

      const updatedBranchOffices = branchOfficesData.map((b) => {
        if (b.id === branchoffice_id) {
          return { ...b, machines: [] };
        }
        return b;
      });
      setBranchOfficesData(updatedBranchOffices);
    }
  }



  return (
    <Modal open={open} onClose={onClose} width={step === 3 ? 540 : 480}>
      <StepIndicator current={step} total={totalSteps} />

      {/* Botones de selección antes del formulario de step 0 */}
      {step === 0 && (
        <div style={{ marginBottom: 24, display: 'flex', gap: 16, justifyContent: 'center' }}>
          <button
            className={`ec-btn${type === 'new' ? ' ec-btn-primary' : ' ec-btn-secondary'}`}
            onClick={() => setType('new')}
            type="button"
          >
            Nuevo evento
          </button>
          <button
            className={`ec-btn${type === 'existing' ? ' ec-btn-primary' : ' ec-btn-secondary'}`}
            onClick={() => setType('existing')}
            type="button"
          >
            Evento existente
          </button>
        </div>
      )}

      {/* Step 0 */}
      {step === 0 && type === 'new' && (
        <div>
          <h2 className="ec-modal-title">¿Cómo se llama el evento?</h2>
          <p className="ec-modal-subtitle">Dale un nombre descriptivo</p>

          <input
            autoFocus
            placeholder="Ej: Envento de Carros"
            value={newEvent.name}
            onChange={(e) => setNewEvent({ ...newEvent, name: e.target.value })}
            className="ec-input ec-input--lg"
            onKeyDown={(e) => e.key === "Enter" && canNext() && nextStep()}
          />

          <div className="ec-form-group--mt">
            <label className="ec-label">Descripción (opcional)</label>
            <textarea
              placeholder="Detalles del evento..."
              value={newEvent.description}
              onChange={(e) => setNewEvent({ ...newEvent, description: e.target.value })}
              className="ec-textarea"
              style={{ minHeight: 60 }}
            />
          </div>
        </div>
      )}
      {/* Aquí puedes agregar el formulario para evento existente si type === 'existing' */}
      {step === 0 && type === 'existing' && (
        <div>
          <h2 className="ec-modal-title">Selecciona un evento existente</h2>
          <p className="ec-modal-subtitle">Puedes usar la configuración de un evento previo</p>
          <Select
            classNamePrefix="ec-input"
            className="ec-input ec-input--lg"
            options={
              Array.from(
                new Map((events || []).map(ev => [ev.id, ev]))
                  .values()
              ).map(ev => ({ value: ev.id, label: ev.name, data: ev }))
            }
            value={selectEventToUpdate ? { value: selectEventToUpdate.id, label: selectEventToUpdate.name } : null}
            onChange={opt => setSelectEventToUpdate(opt.data)}
            placeholder="Selecciona un evento..."
            isClearable
            menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
            menuPosition="fixed"
            styles={{
              control: (base, state) => ({
                ...base,
                border: 'none', // Quitar borde externo
                borderRadius: '12px',
                fontSize: '16px',
                padding: '2px 0',
                background: '#fff',
                color: '#1a1a2e',
                boxShadow: state.isFocused ? '0 0 0 1.5px #94a3b8' : 'none',
                minHeight: 'unset',
              }),
              input: base => ({ ...base, fontFamily: 'DM Sans, sans-serif', color: '#1a1a2e' }),
              option: (base, state) => ({
                ...base,
                fontSize: '15px',
                color: state.isSelected ? '#fff' : '#1a1a2e',
                background: state.isSelected ? '#1a1a2e' : state.isFocused ? '#f1f5f9' : '#fff',
                cursor: 'pointer',
              }),
              singleValue: base => ({ ...base, color: '#1a1a2e' }),
              menu: base => ({ ...base, zIndex: 9999 }),
              menuPortal: base => ({ ...base, zIndex: 9999 }),
              placeholder: base => ({ ...base, color: '#94a3b8' }),
            }}
          />
          <div className="ec-form-group--mt">
            <label className="ec-label">Descripción (opcional)</label>
            <textarea
              placeholder="Detalles del evento..."
              value={newEvent.description}
              onChange={(e) => setNewEvent({ ...newEvent, description: e.target.value })}
              className="ec-textarea"
              style={{ minHeight: 60 }}
            />
          </div>
        </div>
      )}

      {/* Step 1 */}
      {step === 1 && (
        <div>
          <h2 className="ec-modal-title">¿Cuándo será?</h2>
          <p className="ec-modal-subtitle">Selecciona inicio y fin</p>

          <div className="ec-range-wrap">
            <RangeCalendar
              start={newEvent.start}
              end={newEvent.end}
              onRangeChange={(s, e) => setNewEvent({ ...newEvent, start: s, end: e })}
              hovered={hovered}
              setHovered={setHovered}
              pickerMonth={rangePM}
              pickerYear={rangePY}
              setPickerMonth={setRangePM}
              setPickerYear={setRangePY}
              compact={mobile}
            />
          </div>
        </div>
      )}

      {/* Step 2 */}
      {step === 2 && (
        <div>
          <h2 className="ec-modal-title">¿En qué sucursales?</h2>
          <p className="ec-modal-subtitle">Selecciona las sucursales involucradas</p>
          <div className="ec-machine-list">
            {branchOfficesData.map((b) => {
              const sel = newEvent.branches.includes(b.id);
              return (
                <button
                  key={b.id}
                  onClick={() => {
                    const newBranches = sel
                      ? newEvent.branches.filter((x) => x !== b.id)
                      : [...newEvent.branches, b.id];

                    const newBM = { ...newEvent.branchMachines };
                    if (!sel) newBM[b.id] = newBM[b.id] || [];
                    else delete newBM[b.id];

                    setNewEvent({ ...newEvent, branches: newBranches, branchMachines: newBM });
                    getMachines(b.id);

                  }}
                  className="ec-branch-option"
                  style={sel ? { borderColor: b.color, background: b.color + "06" } : {}}
                >
                  <div className={`ec-branch-icon${sel ? "" : " ec-branch-icon--inactive"}`} style={sel ? { background: b.color + "18" } : {}}>
                    {b.icon}
                  </div>
                  <div>
                    <div className={`ec-branch-name${sel ? "" : " ec-branch-name--inactive"}`} style={sel ? { color: b.color } : {}}>
                      {b.name}
                    </div>
                    <div className="ec-branch-address">{b.address}</div>
                  </div>
                  {sel && <span className="ec-branch-check">✓</span>}
                </button>
              );
            })}
          </div>
        </div>
      )}

      {/* Step 3 */}
      {step === 3 && (
        <div>
          <h2 className="ec-modal-title">Asignar máquinas</h2>
          <p className="ec-modal-subtitle">Cada máquina solo puede estar en una sucursal</p>

          <BranchMachineAssign
            branches={newEvent.branches}
            branchMachines={newEvent.branchMachines}
            onChange={(bm) => setNewEvent({ ...newEvent, branchMachines: bm })}
            branchOfficesData={branchOfficesData}
          />
        </div>
      )}

      {/* Step 4 */}
      {step === 4 && (
        <div>
          <h2 className="ec-modal-title">Confirmar evento</h2>
          <p className="ec-modal-subtitle">Revisa los detalles</p>

          <div className="ec-confirm-card">
            <div className="ec-confirm-row">
              <label className="ec-detail-label">Evento</label>
              <div className="ec-confirm-value">{type === "new" ? newEvent.name : selectEventToUpdate.name}</div>
            </div>

            {newEvent.description && (
              <div className="ec-confirm-row">
                <label className="ec-detail-label">Descripción</label>
                <div className="ec-confirm-text">{newEvent.description}</div>
              </div>
            )}

            <div className="ec-confirm-row">
              <label className="ec-detail-label">Fechas</label>
              <div className="ec-confirm-text">{formatDate(newEvent.start)} → {formatDate(newEvent.end)}</div>
            </div>

            <div>
              {newEvent.branches.length > 0 && (<>
                <label className="ec-detail-label">Sucursales y máquinas</label>
                {newEvent.branches.map((bId) => {
                  const branch = branchOfficesData.find((b) => b.id === bId);
                  const machineIds = newEvent.branchMachines[bId] || [];
                  if (!branch) return null;

                  return (
                    <div key={bId} className="ec-confirm-branch">
                      <div className="ec-confirm-branch-name">
                        <span>{branch.icon}</span>
                        <span style={{ color: branch.color }}>{branch.name}</span>
                      </div>

                      <div className="ec-confirm-branch-machines">
                        {machineIds.length === 0 && <span style={{ fontSize: 11, color: "#b0b8c4" }}>Sin máquinas</span>}
                        {machineIds.map((mId) => {
                          const m = branch?.machines.find((x) => x.id === mId);
                          return m ? (
                            <span key={mId} className="ec-machine-badge--lg" style={{ background: m.color + "14", color: m.color }}>
                              {m.name}
                            </span>
                          ) : null;
                        })}
                      </div>
                    </div>
                  );
                })}
                

                  {/* Switch para indicar si lleva ecommerce */}
            <div className="ec-confirm-row mt-2">
              <label className="ec-detail-label">¿Lleva Ecommerce?</label>
              <span
                className={`ec-switch${newEvent.hasEcommerce ? ' ec-switch--on' : ''}`}
                style={{
                  display: 'inline-block',
                  width: 44,
                  height: 24,
                  borderRadius: 12,
                  background: newEvent.hasEcommerce ? '#1a1a2e' : '#e5e7eb',
                  position: 'relative',
                  cursor: 'pointer',
                  marginLeft: 8,
                  transition: 'background 0.2s',
                }}
                onClick={() => {
                  if (newEvent.hasEcommerce) {
                    // Si se apaga, limpiar selección y branchMachines
                    let updatedEvent = { ...newEvent, hasEcommerce: false, selectedEcommerceMachine: "" };
                    const newBM = { ...newEvent.branchMachines };
                    if (newEvent.selectedEcommerceMachine) {
                      // Buscar la sucursal anterior
                      const prevBranch = branchOfficesData.find(b => b.machines && b.machines.some(m => m.id === newEvent.selectedEcommerceMachine));
                      if (prevBranch && newBM[prevBranch.id]) {
                        newBM[prevBranch.id] = newBM[prevBranch.id].filter(id => id !== newEvent.selectedEcommerceMachine);
                        if (newBM[prevBranch.id].length === 0) delete newBM[prevBranch.id];
                      }
                    }
                    updatedEvent.branchMachines = newBM;
                    setNewEvent(updatedEvent);
                  } else {
                    setNewEvent({ ...newEvent, hasEcommerce: true });
                  }
                }}
              >
                <span
                  style={{
                    display: 'block',
                    width: 20,
                    height: 20,
                    borderRadius: '50%',
                    background: '#fff',
                    position: 'absolute',
                    top: 2,
                    left: newEvent.hasEcommerce ? 22 : 2,
                    boxShadow: '0 1px 4px #0001',
                    transition: 'left 0.2s',
                  }}
                />
              </span>
            </div>

            {/* Select de ecommerce solo si lleva ecommerce */}
            {newEvent.hasEcommerce && (
              <div className="ec-confirm-row">
                <label className="ec-detail-label">Selecciona Ecommerce</label>
                <Select
                  classNamePrefix="ec-input"
                  className="ec-input ec-input--lg"
                  options={branchOfficesData
                    .filter(b => b.machines && b.machines.some(m => m.type === "Smartpay Ecommerce"))
                    .map(b => {
                      const ecommerceMachine = b.machines.find(m => m.type === "Smartpay Ecommerce");
                      return ecommerceMachine ? {
                        value: ecommerceMachine.id,
                        label: `${b.name} - ${ecommerceMachine.name}`,
                        branchId: b.id,
                        machine: ecommerceMachine
                      } : null;
                    })
                    .filter(Boolean)
                  }
                  value={newEvent.selectedEcommerceMachine
                    ? branchOfficesData
                      .filter(b => b.machines && b.machines.some(m => m.type === "Smartpay Ecommerce"))
                      .map(b => {
                        const ecommerceMachine = b.machines.find(m => m.type === "Smartpay Ecommerce");
                        return ecommerceMachine && ecommerceMachine.id === newEvent.selectedEcommerceMachine
                          ? { value: ecommerceMachine.id, label: `${b.name} - ${ecommerceMachine.name}` } : null;
                      })
                      .find(Boolean)
                    : null
                  }
                  onChange={opt => {
                    // Actualiza el id seleccionado
                    let updatedEvent = { ...newEvent, selectedEcommerceMachine: opt ? opt.value : "" };
                    const newBM = { ...newEvent.branchMachines };
                    // Remover el anterior si existía
                    if (newEvent.selectedEcommerceMachine) {
                      // Buscar la sucursal anterior
                      const prevBranch = branchOfficesData.find(b => b.machines && b.machines.some(m => m.id === newEvent.selectedEcommerceMachine));
                      if (prevBranch && newBM[prevBranch.id]) {
                        newBM[prevBranch.id] = newBM[prevBranch.id].filter(id => id !== newEvent.selectedEcommerceMachine);
                        // Si queda vacío, eliminar la propiedad
                        if (newBM[prevBranch.id].length === 0) delete newBM[prevBranch.id];
                      }
                    }
                    // Si hay nueva selección, agregarla
                    if (opt && opt.branchId && opt.value) {
                      newBM[opt.branchId] = Array.isArray(newBM[opt.branchId])
                        ? [...newBM[opt.branchId].filter(id => id !== opt.value), opt.value]
                        : [opt.value];
                    }
                    updatedEvent.branchMachines = newBM;
                    setNewEvent(updatedEvent);
                  }}
                  placeholder="Selecciona una sucursal y máquina"
                  isClearable
                  menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                  menuPosition="fixed"
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      border: 'none',
                      borderRadius: '12px',
                      fontSize: '16px',
                      padding: '2px 0',
                      background: '#fff',
                      color: '#1a1a2e',
                      boxShadow: state.isFocused ? '0 0 0 1.5px #94a3b8' : 'none',
                      minHeight: 'unset',
                    }),
                    input: base => ({ ...base, fontFamily: 'DM Sans, sans-serif', color: '#1a1a2e' }),
                    option: (base, state) => ({
                      ...base,
                      fontSize: '15px',
                      color: state.isSelected ? '#fff' : '#1a1a2e',
                      background: state.isSelected ? '#1a1a2e' : state.isFocused ? '#f1f5f9' : '#fff',
                      cursor: 'pointer',
                    }),
                    singleValue: base => ({ ...base, color: '#1a1a2e' }),
                    menu: base => ({ ...base, zIndex: 9999 }),
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                    placeholder: base => ({ ...base, color: '#94a3b8' }),
                  }}
                />
              </div>
            )}
                
                </>)}
            </div>


          
          </div>



          <div className="ec-form-group--mt">
            <label className="ec-label">Publico</label>
            <input
              type="number"
              placeholder="1"
              value={newEvent.public}
              onChange={(e) => setNewEvent({ ...newEvent, public: e.target.value })}
              className="ec-textarea"
              style={{ minHeight: 50 }}
            />
          </div>
        </div>
      )}

      <div className="ec-step-nav">
        {step > 0 ? <button onClick={() => {
          // Si es existing y estamos en el paso de sucursal y no hay sucursal seleccionada, saltar al resumen
          if (step === 4 && type === 'existing') {
            prevStep(); // step 3
            prevStep(); // step 4
            prevStep(); // step 5
          } else {
            prevStep();
          }
        }} className="ec-btn-secondary">← Atrás</button> : <div />}
        {step < totalSteps - 1 ? (
          <button
            onClick={() => {
              // Si es existing y estamos en el paso de sucursal y no hay sucursal seleccionada, saltar al resumen
              if (step === 1 && type === 'existing') {
                nextStep(); // step 3
                //nextStep(); // step 4
                //nextStep(); // step 5
              } else {
                nextStep();
              }
            }}
            disabled={
              step === 2 && type === 'new' && newEvent.branches.length === 0
            }
            className="ec-btn-primary"
          >Siguiente →</button>
        ) : (
          <button onClick={() => onCreate(type === "new" ? "new" : "assign")} className="ec-btn-primary">{type === "new" ? "Crear evento ✓" : "Nueva fecha de evento ✓"}</button>
        )}
      </div>
    </Modal>
  );
}
